import {ref, onMounted, onUnmounted} from 'vue';

export default function useCollapse(e) {
    function setupCollapse () {
        const collapse = document.querySelectorAll('[data-toggle=collapse]');
        collapse.forEach((item) => {
            item.addEventListener('click', function () {
                const target = document.querySelector(item.getAttribute('data-collapse-target'));
                if (target.classList.contains('hidden')) {
                    this.attributes.removeNamedItem('data-collapse-collapsed');
                    this.setAttribute('data-collapse-collapse', '');
                    target.classList.remove('hidden');
                    target.attributes.removeNamedItem('data-collapse-collapsed');
                    target.setAttribute('data-collapse-collapse', '');
                    target.setAttribute('aria-visible', "true");
                } else {
                    this.attributes.removeNamedItem('data-collapse-collapse');
                    this.setAttribute('data-collapse-collapsed', '');
                    target.classList.add('hidden');
                    target.setAttribute('data-collapse-collapsed', '');
                    target.attributes.removeNamedItem('data-collapse-collapse');
                    target.setAttribute('aria-visible', "false");
                }
            });
        });
    }



    onMounted(setupCollapse);

    return ref;
}
